// ------------------------------------
// Constants
// ------------------------------------
export const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE'
export const SET_CONNECTOR_TYPE = 'SET_CONNECTOR_TYPE'
export const SET_FIBER_TYPE = 'SET_FIBER_TYPE'
export const SET_CABLE_TYPE = 'SET_CABLE_TYPE'
export const SET_CABLE_LENGTH = 'SET_CABLE_LENGTH'
export const SET_PACKAGING_TYPE = 'SET_PACKAGING_TYPE'
export const SET_OPTIONAL_ATTRIBUTES = 'SET_OPTIONAL_ATTRIBUTES'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_QUANTITY = 'SET_QUANTITY'
export const RESET_ORDER = 'RESET_ORDER'

// ------------------------------------
// Actions
// ------------------------------------
export const setProductType = ({ product_type }) => ({
    type: SET_PRODUCT_TYPE,
    product_type
});

export const setConnectorType = ({ connector_type }) => ({
    type: SET_CONNECTOR_TYPE,
    connector_type
});

export const setFiberType = ({ fiber_type }) => ({
    type: SET_FIBER_TYPE,
    fiber_type
});

export const setCableType = ({ cable_type }) => ({
    type: SET_CABLE_TYPE,
    cable_type
});

export const setCableLength = ({ cable_length }) => ({
    type: SET_CABLE_LENGTH,
    cable_length
});

export const setPackagingType = ({ packaging_type }) => ({
    type: SET_PACKAGING_TYPE,
    packaging_type
});

export const setOptionalAttributes = ({ optional_attributes }) => ({
    type: SET_OPTIONAL_ATTRIBUTES,
    optional_attributes
});

export const setProduct = ({ product }) => ({
    type: SET_PRODUCT,
    product
});

export const setQuantity = ({ quantity }) => ({
    type: SET_QUANTITY,
    quantity
});

export const resetOrder = () => ({
    type: RESET_ORDER
});


// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    product_type: null,
    connector_type: null,
    fiber_type: null,
    cable_type: null,
    cable_length: null,
    packaging_type: null,
    optional_attributes: null,
    product: null,
    quantity: 1
};

const order = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCT_TYPE:
            return {
                ...state,
                product_type: action.product_type,
                connector_type: initialState.connector_type,
                fiber_type: initialState.fiber_type,
                cable_type: initialState.cable_type,
                cable_length: initialState.cable_length,
                packaging_type: initialState.packaging_type,
                product: initialState.product,
                optional_attributes: initialState.optional_attributes
            }
        case SET_CONNECTOR_TYPE:
            return {
                ...state,
                connector_type: action.connector_type,
                fiber_type: initialState.fiber_type,
                cable_type: initialState.cable_type,
                cable_length: initialState.cable_length,
                packaging_type: initialState.packaging_type,
                product: initialState.product,
                optional_attributes: initialState.optional_attributes
            }
        case SET_FIBER_TYPE:
            return {
                ...state,
                fiber_type: action.fiber_type,
                cable_type: initialState.cable_type,
                cable_length: initialState.cable_length,
                packaging_type: initialState.packaging_type,
                product: initialState.product,
                optional_attributes: initialState.optional_attributes
            }
        case SET_CABLE_TYPE:
            return {
                ...state,
                cable_type: action.cable_type,
                cable_length: initialState.cable_length,
                packaging_type: initialState.packaging_type,
                product: initialState.product,
                optional_attributes: initialState.optional_attributes
            }
        case SET_CABLE_LENGTH:
            return {
                ...state,
                cable_length: action.cable_length,
                packaging_type: initialState.packaging_type,
                product: initialState.product,
                optional_attributes: initialState.optional_attributes
            }
        case SET_PACKAGING_TYPE:
            return {
                ...state,
                packaging_type: action.packaging_type,
                optional_attributes: initialState.optional_attributes
            }
        case SET_OPTIONAL_ATTRIBUTES:
            return {
                ...state,
                optional_attributes: action.optional_attributes
            }
        case SET_PRODUCT:
            return {
                ...state,
                product: action.product
            }
        case SET_QUANTITY:
            return {
                ...state,
                quantity: action.quantity
            }

        case RESET_ORDER:
            return {
                ...state,
                product_type: initialState.product_type,
                connector_type: initialState.connector_type,
                fiber_type: initialState.fiber_type,
                cable_type: initialState.cable_type,
                cable_length: initialState.cable_length,
                packaging_type: initialState.packaging_type,
                optional_attributes: initialState.optional_attributes,
                product: initialState.product,
                quantity: initialState.quantity
            }
        default:
            return state
    }
}

export default order


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/order.js